









import Vue from 'vue'
import FoldableBar from '@/components/FoldableBar/index.vue'

export default Vue.extend({
  data() {
    return {
      factories: [],
    }
  },
  mounted() {
    this.fetchAllFactories()
  },
  methods: {
    fetchAllFactories() {
      this.$http.get('/mes/factory').then(({ data }) => {
        this.factories = data.totalCount > 0 ? data.factories : []
      })
    },
  },
  components: {
    FoldableBar,
  },
})
